export default __webpack_public_path__ + "static/media/close.ab2fab27.svg";